"use client"
import { LANGCODE_CT, LANGCODE_EN, LanguageProvider } from '@/app/utils/LanguageContext';
import "@/app/style/global.scss";
import Script from 'next/script';
export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
     <div className='contentRoot'> {children}</div>
  );
}
